import React, { useState, useEffect } from 'react';
import { LoadingIcon, Button } from '@prosolve/common-components-ui'
import useDataFeedback from '../../../../dataHooks/useDataFeedback';
import EventFeedbackSummary from './EventFeedbackSummary';
import EventFeedbackDetails from './EventFeedbackDetails';
import { FaDownload } from 'react-icons/fa';

export default ({
  eventData = {}
}) => {

  const eventId = eventData.id

  const [isLoading, setIsLoading] = useState(false);

  const [feedbackData, setFeedbackData] = useState({})

  const {
    fetchFeedback,
    downloadFeedback
  } = useDataFeedback();

  const getFeedback = async (eventId) => {
    setIsLoading(true)
    try {
      const fbackData = await fetchFeedback(eventId);
      setFeedbackData(fbackData)
    } catch (e) {
      setFeedbackData({})
    }
    setIsLoading(false)
  }

  useEffect(() => {
    getFeedback(eventId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  const onDownloadFeedback = async () => {
    await downloadFeedback(eventId)
  }

  return (
    <div
      style={{
        // padding: '20px'
      }}
    >
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div
            style={{
              padding: '20px'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center'
            }}>
              <div style={{
                flex: 1,
                color: '#565656',
                fontSize: '24px',
                fontWeight: 'bold',
                marginLeft: '20px'
              }}>
                {`Feedback & Metrics`}
              </div>
              <Button
                style={{
                  display: 'inline-flex',
                  padding: '8px 16px',
                  marginRight: '20px'
                }}
                onClick={onDownloadFeedback}
              >
                <FaDownload style={{ marginRight: '10px', color: '#0280c6' }} />
                <span style={{ fontWeight: 'bold', color: '#565656' }}>{'Download'}</span>
              </Button>
            </div>
            <EventFeedbackSummary feedbackData={feedbackData} />
            <EventFeedbackDetails feedbackData={feedbackData} />
          </div>
      }
    </div>
  )
}